import styled from 'styled-components';


export const RedTigerWidgetFrameContainerDefaultBox = styled.iframe`
    pointer-events: none;
    width: 100%;
    height: 100%;
    border-radius: 10px;
`;
